import Axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { useCallback } from 'react';
import { useConfig } from '@/contexts/ConfigContext';
import { useMemo } from 'react';
import { useAuthTokenReseller } from './useAuthTokenReseller';

export const useAxiosReseller = <T>(): ((
  config: AxiosRequestConfig,
) => Promise<T>) => {
  const { resellerUrl } = useConfig();
  const { accessToken } = useAuthTokenReseller();

  const resellerAxios = useMemo(() => {
    return Axios.create({
      baseURL: resellerUrl,
    });
  }, [resellerUrl]);

  return useCallback(
    async (config: AxiosRequestConfig) => {
      const source = Axios.CancelToken.source();

      if (!config.url?.startsWith('/public/')) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        };
      }

      const promise = resellerAxios({
        ...config,
        cancelToken: source.token,
      }).then(({ data }) => data);

      // @ts-expect-error allow cancellations
      promise.cancel = () => {
        console.log('Query was cancelled by React Query');
        source.cancel('Query was cancelled by React Query');
      };

      return promise;
    },
    [accessToken, resellerAxios],
  );
};

export type ErrorType<Error> = AxiosError<Error>;
